enum ButtonSize {
    Sm = 'sm',
    Md = 'md',
    Lg = 'lg',
    Xl = 'xl',
    Xxl = 'xxl'
}

export default ButtonSize;
